import React from "react";
import close from "../../../assets/images/close.svg";
import { Editor } from "@monaco-editor/react";

const ObjectViewModel = ({ data, name, handleshowPopup }) => {
  return (
    <div className="schedular-popup notification-popup object-view-modal">
      <div className="popup-title">
        <h2>{name}</h2>
        <div className="d-flex align-items-center gap-3">
          <img
            src={close}
            alt="close"
            id="notification-main"
            className="cursor-pointer"
            onClick={handleshowPopup}
          />
        </div>
      </div>
      <div className="popup-body " id="object-view-body">
        <Editor
          height="45vh"
          // width={"60vh"}
          language={"json"}
          value={data}
          options={{
            readOnly: true,
            minimap: { enabled: false },
          }}
        />
      </div>
    </div>
  );
};

export default ObjectViewModel;
